"use client";

import Image from "next/image";
import type { ReactNode } from "react";
import { CardContent, CardHeader } from "@/components/ui/card";
import { Typography } from "@/components/ui/typography";
import { useTranslation } from "@/i18n/client";
import logoEvaluarIsotype from "@/public/images/logos/evaluar-isotype.svg";
import logoEvaluarMain from "@/public/images/logos/evaluar-main.svg";

interface LeftCardControlledLoginContentProps {
  children: ReactNode;
}

export default function LeftCardControlledLoginContent({
  children,
}: LeftCardControlledLoginContentProps) {
  const { t: tLeftCardControlledLoginContent } = useTranslation(
    "left-card-controlled-login-content"
  );
  const { t: tGlobal } = useTranslation("global");
  return (
    <div className="flex flex-col h-full">
      <CardHeader className="p-0 mt-6 lg:px-10 lg:pt-10 lg:mt-0">
        <Image
          alt={tGlobal("altEvaluarMainLogo")}
          className="lg:hidden mx-auto mb-5"
          height={20}
          src={logoEvaluarMain}
          width={100}
        />
        <Image
          alt={tGlobal("altEvaluarMainLogo")}
          className="hidden lg:block"
          height={30}
          src={logoEvaluarIsotype}
          width={40}
        />
        <Typography
          className="lg:hidden inline-block text-neutral-700 text-center w-full"
          variant="label 5"
        >
          {tLeftCardControlledLoginContent("headerMobile1")}{" "}
          <Typography variant="label 4">
            {tLeftCardControlledLoginContent("headerMobile2")}
          </Typography>
        </Typography>
        <Typography className="hidden lg:block text-neutral-700" variant="heading 4">
          {tLeftCardControlledLoginContent("headerDesktop")}
        </Typography>
      </CardHeader>
      <CardContent className="p-0 lg:px-10 lg:pb-10 h-full flex flex-col justify-center">
        {children}
      </CardContent>
    </div>
  );
}
